module.exports = __webpack_public_path__ + "img/check-in.443b5dea.svg";